module.exports = __webpack_public_path__ + "static/media/sugerencias.30dabaf5.svg";